import Box from "@ui-kit/layout/Box/Box.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import { useCallback, useEffect, useState } from "react";
// eslint-disable-next-line import/no-cycle
import AuthorizeCardCvCElement from "../AuthorizeCardCvcElement/AuthorizeCardCvcElement.web";
import AuthorizeCardExpiryElement from "../AuthorizeCardExpiryElement/AuthorizeCardExpiryElement.web";
// eslint-disable-next-line import/no-cycle
import AuthorizeCardNumberElement from "../AuthorizeCardNumberElement/AuthorizeCardNumberElement.web";

function AuthorizeCardElement({
  onValidFields,
  onInvalidFields,
}: {
  /**
   * Fires when the fields used internally by this component is deemed valid
   */
  onValidFields?: () => void;
  /**
   * Function called when the fields used internally by this component is deemed invalid
   */
  onInvalidFields?: () => void;
}) {
  const [validFields, setValidFields] = useState({
    number: false,
    expiry: false,
    cvc: false,
  });

  useEffect(() => {
    if (validFields.number && validFields.expiry && validFields.cvc) {
      onValidFields?.();
    } else {
      onInvalidFields?.();
    }
  }, [validFields, onValidFields, onInvalidFields]);

  const handleFieldValidation = useCallback(
    (fieldName: keyof typeof validFields, isValid: boolean) => {
      setValidFields((prev) => ({ ...prev, [fieldName]: isValid }));
    },
    []
  );

  return (
    <Box
      style={{
        background: "transparent",
      }}
    >
      <Box mt="xs" mb="xs">
        <AuthorizeCardNumberElement
          onValidField={useCallback(() => {
            handleFieldValidation("number", true);
          }, [handleFieldValidation])}
          onInvalidField={useCallback(() => {
            handleFieldValidation("number", false);
          }, [handleFieldValidation])}
        />
      </Box>
      <Flex mt="xs" mb="xs" gap="xs">
        <Box
          style={{
            flex: 1,
          }}
        >
          <AuthorizeCardExpiryElement
            onValidField={useCallback(() => {
              handleFieldValidation("expiry", true);
            }, [handleFieldValidation])}
            onInvalidField={useCallback(() => {
              handleFieldValidation("expiry", false);
            }, [handleFieldValidation])}
          />
        </Box>
        <Box
          style={{
            flex: 1,
          }}
        >
          <AuthorizeCardCvCElement
            onValidField={useCallback(() => {
              handleFieldValidation("cvc", true);
            }, [handleFieldValidation])}
            onInvalidField={useCallback(() => {
              handleFieldValidation("cvc", false);
            }, [handleFieldValidation])}
          />
        </Box>
      </Flex>
    </Box>
  );
}

export default AuthorizeCardElement;

export type AuthorizeCardElementProps = {
  //
};
